const SalesTarget = {

    // FIELDS
    "division": "Division",
    "sales_person": "Sales Person",
    "financial_year": "Financial Year",
    "quarter1": "Quarter 1",
    "quarter2": "Quarter 2",
    "quarter3": "Quarter 3",
    "quarter4": "Quarter 4",
    "total": "Total",
    "fy_sale": "Last Financial Year Sales",
    "category": "Category",
    "sub_category": "Sub Category",
    "search": "Search",

    // PAGE HEADER
    "sales_target": "Sales Target",

    // SWEET ALERT
    "sales_person_not_found": "Sales Person Not Found",
    "select_sales_person": "Select Sales Person",

    // ERROR
    "error_division": "Select Division",
    "error_sales_person": "Select Sales Person",
    "error_financial_year": "Select Financial Year",
    "error_category": "Category Not Found",
    "error_target_amount_q1": "Enter Amount",
    "error_target_amount_q2": "Enter Amount",
    "error_target_amount_q3": "Enter Amount",
    "error_target_amount_q4": "Enter Amount",
    "error_positive_no": "Cannot be Negative",

    // TABLE HEADER
    "table_sales_person": "SALES PERSON",
    "table_division": "DIVISION",
    "table_fy": "FINANCIAL YEAR",
}

export default SalesTarget;